import TEXT from '../../../assets/constants';
import { CHART_KEY_NUMERICAL_CONSTS } from '../../container/Activity/ChartRegion/helpers/graphConstants';

export const getDialysisInfo = (risk, treatment, age, egfrInitial) => {
  let declineFactor;
  let declineFactorTreatment;
  let declineFactorTreatmentString;
  let riskReduction;
  let heartFailureRate;
  const nominalHeartFailureRate = 5.3;

  if (risk === TEXT.QUESTIONNAIRE.HIGH_RISK) {
    declineFactor = 5.9;
  } else {
    declineFactor = 3.3;
  }

  const declineFactorNoTreatmentString = `${declineFactor}`;

  if (treatment === TEXT.QUESTIONNAIRE.RAAS_INHIBITOR) {
    declineFactorTreatment = declineFactor * (1 - 0.15);
    declineFactorTreatmentString = `${declineFactor} * (0.85)`;
    riskReduction = 26;
    heartFailureRate = 3.9;
  } else if (
    treatment === TEXT.QUESTIONNAIRE.RAAS_INHIBITOR_AND_SGLT2_INHIBITOR
  ) {
    declineFactorTreatment = declineFactor * (1 - 0.15) * (1 - 0.5);
    declineFactorTreatmentString = `${declineFactor} * (0.85) * (0.50)`;
    riskReduction = 55;
    heartFailureRate = 2.379;
  } else if (
    treatment ===
    TEXT.QUESTIONNAIRE.RAAS_INHIBITOR_AND_SGLT2_INHIBITOR_AND_NSMRA
  ) {
    declineFactorTreatment =
      declineFactor * (1 - 0.15) * (1 - 0.5) * (1 - 0.32);
    declineFactorTreatmentString = `${declineFactor} * (0.85) * (0.50) * (0.68)`;
    riskReduction = 65;
    heartFailureRate = 1.86;
  } else if (
    treatment ===
    TEXT.QUESTIONNAIRE.RAAS_INHIBITOR_AND_SGLT2_INHIBITOR_AND_GLP1RA
  ) {
    declineFactorTreatment =
      declineFactor * (1 - 0.15) * (1 - 0.5) * (1 - 0.35);
    declineFactorTreatmentString = `${declineFactor} * (0.85) * (0.50) * (0.65)`;
    riskReduction = 70;
    heartFailureRate = 1.61;
  } else if (treatment === TEXT.QUESTIONNAIRE.FOUR_DRUG_THERAPY) {
    declineFactorTreatment =
      declineFactor * (1 - 0.15) * (1 - 0.5) * (1 - 0.32) * (1 - 0.35);
    declineFactorTreatmentString = `${declineFactor} * (0.85) * (0.50) * (0.68) * (0.65)`;
    riskReduction = 74;
    heartFailureRate = 1.35;
  } else {
    declineFactorTreatment =
      declineFactor * (1 - 0.15) * (1 - 0.5) * (1 - 0.32);
    declineFactorTreatmentString = `${declineFactor} * (0.85) * (0.50) * (0.68)`;
    riskReduction = 65;
    heartFailureRate = 1.9;
  }

  const timeToDialysisTreatment =
    (egfrInitial - CHART_KEY_NUMERICAL_CONSTS.DIALYSIS_ONSET) /
    declineFactorTreatment;
  const treatmentDialysisAge = timeToDialysisTreatment + age;
  const timeToDialysisNoTreatment =
    (egfrInitial - CHART_KEY_NUMERICAL_CONSTS.DIALYSIS_ONSET) / declineFactor;
  const noTreatmentDialysisAge = timeToDialysisNoTreatment + age;

  const footnoteStrings = [
    {
      label: '1',
      text: `Time to dialysis without treatment: (${egfrInitial} - ${CHART_KEY_NUMERICAL_CONSTS.DIALYSIS_ONSET}) / ${declineFactorNoTreatmentString} = ${timeToDialysisNoTreatment.toFixed(1)} years`,
    },
    {
      label: '2',
      text: `Time to dialysis with treatment: (${egfrInitial} - ${CHART_KEY_NUMERICAL_CONSTS.DIALYSIS_ONSET}) / ${declineFactorTreatmentString} = ${timeToDialysisTreatment.toFixed(1)} years`,
    },
    {
      label: '3',
      text: `Age at dialysis without treatment: ${timeToDialysisNoTreatment.toFixed(1)} + ${age} = ${noTreatmentDialysisAge.toFixed(0)} years`,
    },
    {
      label: '4',
      text: `Age at dialysis with treatment: ${timeToDialysisTreatment.toFixed(1)} + ${age} = ${treatmentDialysisAge.toFixed(0)} years`,
    },
    {
      label: '5',
      text: `eGFR decline rate with treatment: ${declineFactorTreatmentString} = ${declineFactorTreatment.toFixed(2)} mL/min/1.73m²/year`,
    },
    {
      label: '6',
      text: `Heart failure risk reduction: ${riskReduction}% (based on composite treatment effects - equation pending)`,
    },
    {
      label: '7',
      text: `Nominal untreated heart failure hospitalization rate: ${nominalHeartFailureRate}% (based on composite treatment effects - equation pending)`,
    },
    {
      label: '8',
      text: `Heart failure hospitalization rate: ${heartFailureRate}% (based on composite treatment effects - equation pending)`,
    },
  ];

  return {
    noTreatmentDialysisAge: parseInt(noTreatmentDialysisAge.toFixed(0), 10),
    treatmentDialysisAge: parseInt(treatmentDialysisAge.toFixed(0), 10),
    treatmentInitiated: age,
    incidentTrajectoryNoTreatment: declineFactor,
    incidentTrajectoryTreatment: parseFloat(declineFactorTreatment.toFixed(1)),
    heartFailureRate,
    nominalHeartFailureRate,
    riskReduction,
    timeToDialysisTreatment: parseInt(timeToDialysisTreatment.toFixed(0), 10),
    timeToDialysisNoTreatment: parseInt(
      timeToDialysisNoTreatment.toFixed(0),
      10
    ),
    footnoteStrings,
  };
};
